<template>
    <x-page title="Add Metric Record">
        <template #header-actions>
            <x-back-button :disabled="isLoading" />
        </template>
        <metric-record-form id="metric-record-form"
            @submit="handleSubmit"
            :disabled="isLoading"
            :errors="errors"
            :initialFields="initialFields" />
        <template #footer>
            <x-submit-button form="metric-record-form"
                :is-loading="isLoading"
                :disabled="isLoading" />
        </template>
    </x-page>
</template>

<script>
import XBackButton from '../../components/XBackButton.vue'
import XPage from '../../components/XPage.vue'
import XSubmitButton from '../../components/XSubmitButton.vue'
import { handleValidationXhrError } from '../../helpers'
import MetricRecordForm from './MetricRecordForm.vue'
import MetricRecordMixin from './mixins/MetricRecordFormMixin'

export default {
    components: {
        XPage,
        XBackButton,
        XSubmitButton,
        MetricRecordForm,
    },
    data() {
        return {
            errors: null,
            initialFields: {
                values: this.getDefaultMetrics(),
            },
            isLoading: false,
        }
    },
    methods: {
        handleSubmit(fields) {
            this.isLoading = true
            const request = axios.post(`/api/metric-records`, {
                ...fields,
                values: this.formatMetrics(fields.values),
            })
            .then(() => {
                this.$notify({
                    type: 'success',
                    title: `Berhasil`,
                    text: `${fields.date} added!`,
                })
                this.$router.back()
            })
            return handleValidationXhrError(request, errors => {
                this.errors = errors
            }).finally(() => {
                this.isLoading = false
            })
        }
    },
    mixins: [
        MetricRecordMixin,
    ],
}
</script>